import { Injectable } from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';
import { SelfService } from '../self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';


@Injectable({
  providedIn: 'root'
})
export class UploadService {
  errorMessage: string;

  constructor(    private diService: SelfService,private spinnerService: Ng4LoadingSpinnerService,private environment1 : EnvironmentConfiguration) { }
  
    bucketEnv: string ='';


public async getPresignedUrl(file,awsDetails, uploadDataForFiles,flag)
{
const accesKey = awsDetails.accessId;
const secretKey = awsDetails.secretKey;
const region = awsDetails.region;
  const bucket = new S3(
    {
      accessKeyId: sessionStorage.getItem('AccessKeyId'),
      secretAccessKey: sessionStorage.getItem('SecretKeyId'),
      sessionToken: sessionStorage.getItem('SessionToken'),
      region:region,

    }
);
var params: any;
console.log('bucket env :'+this.environment1.envName); 

if(this.environment1.envName == "qa"){
  this.bucketEnv = 'qa-bpg-toyota-com-web-content';
}else if(this.environment1.envName == "dev"){
  this.bucketEnv = 'dev.bpg.toyota.com-web-content';
}else if(this.environment1.envName == "prod"){
  this.bucketEnv = 'bpg-toyota-com-web-content';
}else{
  this.bucketEnv = 'dev.bpg.toyota.com-web-content';
}

if(flag == 'resource'){
 params = this.buildUploadParams(this.bucketEnv+'/documents/di_documents/di_resources/'+uploadDataForFiles, file.name,'application/octet-stream', 120);
}
else if(flag=='banner')
{
  params = this.buildUploadParams(this.bucketEnv+'/documents/di_documents/di_banner', uploadDataForFiles,'application/octet-stream', 120);
 
 }
 else if(flag=='news')
 {
   params = this.buildUploadParams(this.bucketEnv+'/documents/di_documents/di_news', uploadDataForFiles,'application/octet-stream', 120);
  
  }
  else if(flag=='naacNews')
  {
    params = this.buildUploadParams(this.bucketEnv+'/documents/naac_documents/naac_news', uploadDataForFiles,'application/octet-stream', 120);
   
   }
   else if(flag=='naacResource')
   {
     params = this.buildUploadParams(this.bucketEnv+'/documents/naac_documents/naac_resources/' +uploadDataForFiles, file.name,'application/octet-stream', 120);
    
    }
    else if(flag=='chapterAnnouncements')
    {
      params = this.buildUploadParams(this.bucketEnv+'/documents/chapter_announcements/' +uploadDataForFiles, file.name,'application/octet-stream', 120);
    } 
    else if(flag=='create-expense')
    {
      params = this.buildUploadParams(this.bucketEnv+'/documents/expense_documents/' +uploadDataForFiles, file.name,'application/octet-stream', 120);
    } 
     else if(flag=='create-event')
    {
      params = this.buildUploadParams(this.bucketEnv+'/documents/event_documents/' +uploadDataForFiles, file.name,'application/octet-stream', 120);
    } 
    else if(flag=='chapter_notification')
    {
      params = this.buildUploadParams(this.bucketEnv+'/documents/chapter-notification/' +uploadDataForFiles, file.name,'application/octet-stream', 120);
    }
else
{
 params = this.buildUploadParams(this.bucketEnv+'/documents/chapter_gallery', uploadDataForFiles,'application/octet-stream', 120);

}

const preSignedGetUrl = bucket.getSignedUrl('putObject', params);
await this.diService.diput(preSignedGetUrl,file).then().catch(function(err) {
  //console.log(err.stack); // This is the only way to see the stack
  //alert(1);
  localStorage.setItem('uploadError','Error')
  throw err; // Where does this go?
}).catch(function(err) {
 // alert(2);
  //console.log(err.stack); // It goes here!
});


this.spinnerService.hide();

}
 

private buildUploadParams(bucket: string, key: string, contentType: string, expires: number): any {
  return {
    Bucket: bucket,
    Key: key,
ContentType: contentType,
    ACL: 'bucket-owner-full-control',
    Expires: expires
  };
}


}
